import { Link } from "react-router-dom";
import HowToUploadGuide from "./components/HowToUploadGuide";
import EmployeeExampleSheet from "./components/EmployeeExampleSheet";

export default function EmployeeImportGuide() {
  return (
    <div className="w-full min-w-0 min-h-screen bg-slate-50 p-4 md:p-8 box-border">
      <div className="max-w-6xl mx-auto space-y-5">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <div>
            <p className="text-sm text-blue-700 font-medium">
              <Link to="/employees?view=import" className="hover:underline">Bulk Import</Link>
            </p>
            <h1 className="text-2xl font-bold text-slate-900 mt-1">Import User Guide</h1>
            <p className="text-sm text-slate-500 mt-1">
              How to prepare your file, map columns, and complete bulk employee import.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          <HowToUploadGuide />
          <EmployeeExampleSheet />
        </div>
      </div>
    </div>
  );
}
